import React, {useState, useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import Menu from "../../../../components/layout/menu/index";
import InputField from "../../../../components/forms/inputField";
import SaveButton from "../../../../components/forms/saveButton";
import CancelButton from "../../../../components/forms/cancelButton";
import UploadDocument from "../../../../components/shared/modals/modalDocument/uploadDocument";
import UploadDocumentButton from "../../../../components/shared/uploadDocument";
import {createUser, downloadExcelTemplate} from "../../../../client/users/index"
import {getRoles} from "../../../../client/role/index"
import {getSubtypes} from "../../../../client/subtypes/index"
import { uploadUsersExcel } from "../../../../client/users/index";
import DownloadDocumentButton from "../../../../components/shared/downloadDocument";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ModalUserError from "../../../../components/shared/modals/users/modalUserError";
import { getSuppliers} from "../../../../client/suppliers"
import { getBuyersGroupList } from "../../../../client/areas"
import SelectSearch from "../../../../components/forms/selectSearch";

export default function UserRegister() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [isLoading, setIsLoading] = useState(false);

  const [selectedRole, setSelectedRole] = useState(null);
  const [roles, setRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(null);
  const [errorRoles, setErrorRoles] = useState(null);

  const [subtypes, setSubtypes] = useState([]);
  const [selectedSubtypes, setSelectedSubtypes] = useState([]);
  const [loadingSubtypes, setLoadingSubtypes] = useState(false);

  const [showModalUploadDocument, setShowModalUploadDocument] = useState(false);

  const [excelData, setExcelData] = useState([]);

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [validationMessages, setValidationMessages] = useState([]);

  const [showModalUserError, setShowModalUserError] = useState(false);
  const [errorExcelData, setErrorExcelData] = useState(null);

  const [buyersGroups, setBuyersGroups] = useState([]);
  const [loadingBuyersGroups, setLoadingBuyersGroups] = useState(false);
  const [selectedBuyerGroups, setSelectedBuyerGroups] = useState(null);

  useEffect(() => {
    const fetchBuyersGroups = async () => {
      try {
        setLoadingBuyersGroups(true);
        const response = await getBuyersGroupList(false);
        setBuyersGroups(response.data.purchasingGroups);
        setLoadingBuyersGroups(false);
      } catch (error) {
        console.error('Error al obtener grupos de compra:', error);
        setLoadingBuyersGroups(false);
      }
    };

    fetchBuyersGroups();
  }, []);

  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        setLoadingSuppliers(true);
        const response = await getSuppliers();
        setSuppliers(response.data);
        setLoadingSuppliers(false);
      } catch (error) {
        console.error('Error al obtener proveedores:', error);
        setLoadingSuppliers(false);
      }
    };

    fetchSuppliers();
  }, []);

  const supplierOptions = suppliers.map(supplier => ({
    value: supplier.id.toString(), 
    label: supplier.name
  }));

  const buyersGroupOptions = [
    ...buyersGroups.map(group => ({
      value: group.id.toString(),
      label: group.group
    })),
    {
      value: "add_new_group",
      label: "Agregar grupo de compra",
      isAddOption: true
    }
  ];

  const handleSupplierChange = (selectedOption) => {
    setSelectedSupplier(selectedOption);
    setUserInputs(prev => ({
      ...prev,
      supplierId: selectedOption ? selectedOption.value : null
    }));
  };

  const handleBuyerGroupsChange = (selectedOption) => {
    if (selectedOption && selectedOption.isAddOption) {
      navigate('/compradores', { 
        state: { 
          showBuyersGroupSection: true
        } 
      });
      setSelectedBuyerGroups(null);
      setUserInputs(prev => ({
        ...prev,
        purchasingGroupId: null
      }));
      return;
    }
    
    setSelectedBuyerGroups(selectedOption);
    setUserInputs(prev => ({
      ...prev,
      purchasingGroupId: selectedOption ? selectedOption.value : null
    }));
  };

  const handleCancel = () => {
    setUserInputs({
      name: "",
      email: "",
      charge: "",
      position: "",
      contact_number: "",
      category: "",
      order_level: "",
      hierarchichal_manage: "",
      functional_area: "",
      personnel_division: "",
      roleId: null,
      subtypeIds: [],
      user_code: "",
      supplierId: "",
      purchasingGroupId: ""
    });
    setSelectedRole(null);
    setSelectedSupplier(null);
    setSelectedSubtypes([]);
  };

  const isUploadEnabled = selectedRole === 1 || selectedRole === 2 || selectedRole === 3 || selectedRole === 4;

  const openModal = () => setShowModalUploadDocument(true);
  const closeModal = () => setShowModalUploadDocument(false);

  const [userInputs, setUserInputs] = useState({
    name: "",
    email: "",
    charge: "",
    position: "",
    contact_number: "",
    category: "",
    order_level: "",
    hierarchichal_manage: "",
    functional_area: "",
    personnel_division: "",
    roleId: null,
    subtypeId: null,
    user_code: "",
    supplierId: "",
    purchasingGroupId: ""
  });

  //////////// CARGA MASIVA DE USUARIOS DESDE EXCEL
  //admin 
  const handleExcelUploadAdmin = async (data, file) => {

    try {
      const response = await uploadUsersExcel(file, selectedRole);

      if (response.data.errors && response.data.errors.length > 0) {
        setErrorMessage(response.data.errors.join(', '));
        setErrorExcelData(response.data.errorExcelBase64); 
        setValidationMessages(response.data.validationMessages || []);
        setShowModalUserError(true);
        return;
      }

      if (response.data.registeredUserIds.length === 0) {
        setErrorMessage('No se pudieron registrar los usuarios. Verifique los datos.');
        setShowModalAlertWarning(true);
        return;
      }
          
      const adminData = data.map((item, index) => ({
        id: response.data.registeredUserIds[index], 
        fullName: item.name,
        email: item.email,
        phone: item.contact_number,
      }));
      
      setExcelData(adminData);
      navigate('/prev-lista-administrador', { 
        state: { 
          excelData: adminData,
          registeredUserIds: response.data.registeredUserIds
        } 
      });
      
    } catch (error) {
      console.error('Error al subir archivo:', error);
      if (error.response?.data?.errors) {
        setErrorMessage(error.response.data.errors.join(', '));
        setErrorExcelData(error.response.data.errorExcelBase64);
        setShowModalUserError(true);
      } else if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
        setShowModalAlertWarning(true);
      } else {
        setErrorMessage('Error al subir el archivo. Por favor verifique el formato.');
        setShowModalAlertWarning(true);
      }
    }
  };

  //comprador
  const handleExcelUploadBuyer = async (data, file) => {
    try {
    const response = await uploadUsersExcel(file, selectedRole);

    if (response.data.errors && response.data.errors.length > 0) {
      setErrorMessage(response.data.errors.join(', '));
      setErrorExcelData(response.data.errorExcelBase64);
      setValidationMessages(response.data.validationMessages || []);
      setShowModalUserError(true);
      return;
    }

    if (response.data.registeredUserIds.length === 0) {
      setErrorMessage('No se pudieron registrar los usuarios. Verifique los datos.');
      setShowModalAlertWarning(true);
      return;
    }

    const buyerData = data.map((item, index) => ({
      id: response.data.registeredUserIds[index],
      fullName: item.name,
      email: item.email,
      phone: item.contact_number,
      charge: item.charge,
      purchasingGroup: item.purchasingGroup,
      subtipos: item.subtipos
    }));


    setExcelData(buyerData);
    navigate('/prev-lista-comprador', { 
      state: { 
          excelData: buyerData,
          registeredUserIds: response.data.registeredUserIds

      } 
    });
    
    } catch (error) {
      console.error('Error al subir archivo:', error);
    if (error.response?.data?.errors) {
      setErrorMessage(error.response.data.errors.join(', '));
      setErrorExcelData(error.response.data.errorExcelBase64);
      setShowModalUserError(true);
    } else if (error.response?.data?.message) {
      setErrorMessage(error.response.data.message);
      setShowModalAlertWarning(true);
    } else {
      setErrorMessage('Error al subir el archivo. Por favor verifique el formato.');
      setShowModalAlertWarning(true);
    }
  }
  };

  //proveedor
  const handleExcelUploadProvider =  async (data, file) => {

    try {
      const response = await uploadUsersExcel(file, selectedRole);

      if (response.data.errors && response.data.errors.length > 0) {
        setErrorMessage(response.data.errors.join(', '));
        setErrorExcelData(response.data.errorExcelBase64);
        setValidationMessages(response.data.validationMessages || []);
        setShowModalUserError(true);
        return;
      }

      if (response.data.registeredUserIds.length === 0) {
        setErrorMessage('No se pudieron registrar los usuarios. Verifique los datos.');
        setShowModalAlertWarning(true);
        return;
      }

      const providerData = data.map((item, index) => ({
        id: response.data.registeredUserIds[index],
        fullName: item.name,
        email: item.email,
        contact_number: item.contact_number,
        charge: item.charge,
        category: item.category,
        supplier: item.supplier
      }));


      setExcelData(providerData);
      navigate('/prev-lista-proveedor', { 
        state: { 
            excelData: providerData,
            registeredUserIds: response.data.registeredUserIds
        } 
      });
    } catch (error) {
      console.error('Error al subir archivo: ', error);
      if (error.response?.data?.errors) {
        setErrorMessage(error.response.data.errors.join(', '));
        setErrorExcelData(error.response.data.errorExcelBase64);
        setShowModalUserError(true);
      } else if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
        setShowModalAlertWarning(true);
      } else {
        setErrorMessage('Error al subir el archivo. Por favor verifique el formato.');
        setShowModalAlertWarning(true);
      }
    }

  };

  //invitado 
  const handleExcelUploadGuest = async (data, file) => {

    try {
      const response = await uploadUsersExcel(file, selectedRole);

      if (response.data.errors && response.data.errors.length > 0) {
        setErrorMessage(response.data.errors.join(', '));
        setErrorExcelData(response.data.errorExcelBase64); 
        setValidationMessages(response.data.validationMessages || []);
        setShowModalUserError(true);
        return;
      }

      if (response.data.registeredUserIds.length === 0) {
        setErrorMessage('No se pudieron registrar los usuarios. Verifique los datos.');
        setShowModalAlertWarning(true);
        return;
      }
      
      const guestData = data.map((item, index) => ({
        id:response.data.registeredUserIds[index],
        user_code: item.user_code,
        fullName: item.name,
        personnel_division: item.personnel_division,
        position: item.position,
        email: item.email,
        hierarchichal_manage: item.hierarchichal_manage,
        functional_area: item.functional_area,
      }));

      setExcelData(guestData);

      navigate('/prev-lista-invitado', { 
        state: { 
            excelData: guestData,
            registeredUserIds: response.data.registeredUserIds
        } 
      });
    
    } catch (error){
      console.error('Error al subir archivo:', error);
    
      if (error.response?.data?.errors) {
        setErrorMessage(error.response.data.errors.join(', '));
        setErrorExcelData(error.response.data.errorExcelBase64);
        setShowModalUserError(true);
      } else if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
        setShowModalAlertWarning(true);
      } else {
        setErrorMessage('Error al subir el archivo. Por favor verifique el formato.');
        setShowModalAlertWarning(true);
      }
    }    
  };

useEffect(() => {
  const fetchSubtypes = async () => {
    try {
      setLoadingSubtypes(true);
      const response = await getSubtypes();
      
      const formattedSubtypes = response.data.map(subtype => ({
        value: subtype.id.toString(),
        label: subtype.name,
        typeId: subtype.typeId
      }));
      
      setSubtypes(formattedSubtypes);
      setLoadingSubtypes(false);
    } catch (error) {
      console.error('Error al obtener subtipos:', error);
      setLoadingSubtypes(false);
    }
  };

  fetchSubtypes();
}, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await getRoles();
        setRoles(response.data); 
        setLoadingRoles(false);
      } catch (error) {
        console.error('Error al obtener roles:', error);
        setErrorRoles('Error al cargar los roles');
        setLoadingRoles(false);
      }
    };

    fetchRoles();
  }, []);
  
  const handleRoleChange = (roleId) => {
    setSelectedRole(roleId);
    setUserInputs(prev => ({
      ...prev,
      roleId: roleId,
      subtypeIds: []
    }));
      setSelectedSubtypes([]); 
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserInputs( prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (selectedRole === 1) {
      if (!userInputs.name.trim()) {
        setErrorMessage('El campo "Nombres y apellidos" es obligatorio para administradores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
      
      if (!userInputs.email.trim()) {
        setErrorMessage('El campo "Correo de la empresa" es obligatorio para administradores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
    }

    //campos obligatorios proveedor
    if (selectedRole === 2) {
      if (!userInputs.name.trim()) {
        setErrorMessage('El campo "Nombres y apellidos" es obligatorio para proveedores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
      
      if (!userInputs.email.trim()) {
        setErrorMessage('El campo "Correo de la empresa" es obligatorio para proveedores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
      
      if (!userInputs.supplierId) {
        setErrorMessage('El campo "Proveedor" es obligatorio para proveedores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
    }

    // campos obligatorios comprador
    if (selectedRole === 3) {
      if (!userInputs.name.trim()) {
        setErrorMessage('El campo "Nombres y apellidos" es obligatorio para compradores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
      
      if (!userInputs.email.trim()) {
        setErrorMessage('El campo "Correo de la empresa" es obligatorio para compradores');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
    }

    //campos obligatorios invitado
    if (selectedRole === 4) {
      if (!userInputs.name.trim()) {
        setErrorMessage('El campo "Nombres y apellidos" es obligatorio para invitados');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
      
      if (!userInputs.email.trim()) {
        setErrorMessage('El campo "Correo" es obligatorio para invitados');
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
    }

    if (userInputs.email) {
      let isValidEmail = true;
      let emailError = 'Por favor ingrese un correo electrónico válido';
      
      if (selectedRole === 1 || selectedRole === 3) { // Rol de administrador y comprador
        isValidEmail = validateEmail(userInputs.email, '@tasa.com.pe');
        emailError = 'El correo electrónico debe pertenecer al dominio @tasa.com.pe';
      } else {
        isValidEmail = validateEmail(userInputs.email);
      }
      
      if (!isValidEmail) {
        setErrorMessage(emailError);
        setShowModalAlertWarning(true);
        setIsLoading(false);
        return;
      }
    }

    if (userInputs.contact_number && !validatePhone(userInputs.contact_number)) {
      setErrorMessage('Por favor ingrese un número de teléfono válido de 9 dígitos');
      setShowModalAlertWarning(true);
      setIsLoading(false);
      return;
    }

    const userPayload = {
      name: userInputs.name,
      email: userInputs.email,
      charge: userInputs.charge || null,
      position: userInputs.position || null,
      contact_number: userInputs.contact_number || null,
      category: userInputs.category || null,
      order_level: userInputs.order_level || null,
      hierarchichal_manage: userInputs.hierarchichal_manage || null,
      functional_area: userInputs.functional_area || null,
      personnel_division: userInputs.personnel_division || null,
      roleId: userInputs.roleId,
      user_code: userInputs.user_code || null,
      supplierId: userInputs.supplierId || null,
      purchasingGroupId: userInputs.purchasingGroupId || null,
      subtypeIds: userInputs.subtypeIds || [],
      enabled_user:true,
    };


    try {
      const response = await createUser(userPayload);
      setSuccessMessage('Usuario registrado correctamente');
      setShowModalSuccess(true);
      setUserInputs({
        name: "",
        email: "",
        charge: "",
        position: "",
        contact_number: "",
        category: "",
        order_level: "",
        hierarchichal_manage: "",
        functional_area: "",
        personnel_division: "",
        roleId: null,
        user_code: "",
        supplierId: "",
        purchasingGroupId: "",
        subtypeIds: []
      });
      setSelectedRole(null);
      setSelectedSupplier(null);
      setSelectedBuyerGroups(null);
      setSelectedSubtypes([]);
    } catch (error) {
      console.error('Error al crear usuario:', error);

      if (error.response?.data?.message) {
        const errorMessage = error.response.data.message;
        setErrorMessage(errorMessage);
        setShowModalAlertWarning(true);
      } else if (error.response?.data?.email) {
        setErrorMessage(error.response.data.email[0] || 'El correo electrónico no es válido');
        setShowModalAlertWarning(true);
      } else {
      setErrorMessage('Error al registrar usuario. Por favor intente nuevamente.');
      setShowModalAlertWarning(true);  
      }
    } finally {
      setIsLoading(false);
    }
  };

  const validateEmail = (email, requiredDomain = null) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    if (!emailRegex.test(email)) {
      return false;
    }
    
    if (requiredDomain && !email.endsWith(requiredDomain)) {
      return false;
    }
    
    return true;
  };

  const validatePhone = (phone) => {
    return /^\d{9}$/.test(phone); 
  };

  const closeModalWarning = () => {
    setShowModalAlertWarning(false);
    setErrorMessage('');
  };

  const closeModalSuccess = () => {
    setShowModalSuccess(false);
    setSuccessMessage('');
  };

  const handleDownloadTemplate = async () => {
    if (!selectedRole) {
      setErrorMessage('Por favor seleccione un rol primero');
      setShowModalAlertWarning(true);
      return;
    }

    try {
      const response = await downloadExcelTemplate(selectedRole);
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      const selectedRoleName = roles.find(r => r.id === selectedRole)?.name || 'usuarios';
      link.setAttribute('download', `Plantilla_${selectedRoleName}.xlsx`);
      
      document.body.appendChild(link);
      link.click();
      
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error al descargar la plantilla:', error);
      setErrorMessage('Error al descargar la plantilla. Por favor intente nuevamente.');
      setShowModalAlertWarning(true);
    }
  };

  const handleSubtypesChange = (selectedOptions) => {
    setSelectedSubtypes(selectedOptions || []);
    
    const subtypeIds = selectedOptions ? selectedOptions.map(option => parseInt(option.value)) : [];
    
    setUserInputs(prev => ({
      ...prev,
      subtypeIds: subtypeIds
    }));
  };

  return (
    <div className="min-h-screen">
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
      <div className={`flex-1  transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className=" pt-[67px] pb-10 min-h-screen flex flex-col justify-between px-[3%] ">    
                <div className="flex flex-col gap-4 pt-8">
                    <div className="flex flex-col items-center justify-between gap-3 md:flex-row">
                        <h1 className="text-blue font-itcbold text-2xl md:text-[32px]">Registrar Usuario</h1>
                        <div className="flex items-center justify-center gap-3">
                          <DownloadDocumentButton
                            text="Descargar Plantilla"
                            onClick={handleDownloadTemplate}
                            disabled={!selectedRole}
                          />
                          <UploadDocumentButton 
                            isEnabled={isUploadEnabled}
                            onClick={openModal}
                            accept=".xlsx, .xls"
                          />
                        </div>

                    </div>
                    <p className="text-[#2F2F3B] text-base md:text-[20px] font-itcmedium">Escoja su rol: <span className="text-red-500">*</span></p>
                    <div className="flex gap-5 ">
                    {loadingRoles ? (
                      <p>Cargando roles...</p>
                    ) : errorRoles ? (
                      <p className="text-red">{errorRoles}</p>
                    ) : (
                      <div className="grid grid-cols-2 gap-5 md:flex ">
                        {roles.map((role) => (
                          <div key={role.id} className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              id={role.id.toString()}
                              checked={selectedRole === role.id}  
                              onChange={() => handleRoleChange(role.id)}
                              className="w-5 h-5 appearance-none checked:bg-[#43B02A] checked:border-transparent cursor-pointer rounded-full  border-[2px] border-[#C4C7CC]"
                            />
                            <label htmlFor={role.id.toString()} className=" text-[#1B1F26B8] text-opacity-[72%] text-[14px] font-itcmedium">
                              {role.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                    </div>
                    {selectedRole && (
                    <p className="text-[#2F2F3B] text-base md:text-[20px] font-itcmedium">Llene su información:</p>
                    )}
                    
                    <div className="grid grid-cols-2 w-full md:grid-cols-3 gap-4 md:w-[90%]">
                     {/**ADMINISTRADOR */}
                    {selectedRole === 1 && (
                        <>
                          <InputField 
                            title="Nombres y apellidos:"
                            placeholder="Nombres y apellidos"
                            name="name"
                            value={userInputs.name}
                            onChange={handleInputChange}
                            validation="letters-only"
                            required={true}
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField
                            title="Correo de la empresa:"
                            placeholder="Correo de la empresa"
                            name="email"
                            value={userInputs.email}
                            onChange={handleInputChange}
                            type="email"
                            validation="email-tasa"
                            required={true}
                            horizontal={false}
                            maxLength={50}
                          />

                          <InputField
                            title="Número de contacto:"
                            placeholder="Número de contacto"
                            name="contact_number"
                            value={userInputs.contact_number}
                            onChange={handleInputChange}
                            validation="phone"
                            horizontal={false}
                            />
                        </>
                      )}

                      {/* Campos para Proveedor */}
                      {selectedRole === 2 && (
                        <>
                          <InputField 
                            title="Nombres y apellidos:"
                            name="name"
                            placeholder="Nombres y apellidos"
                            value={userInputs.name}
                            onChange={handleInputChange}
                            validation="letters-only"
                            required= {true}
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Correo de la empresa"
                            name="email"
                            placeholder="Correo de la empresa"
                            value={userInputs.email}
                            onChange={handleInputChange}
                            type="email"
                            validation="email"
                            required={true}
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField
                            title="Cargo:"
                            placeholder="Cargo"
                            name="charge"
                            value={userInputs.charge}
                            onChange={handleInputChange}
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Número de contacto:"
                            name="contact_number"
                            placeholder="Número de contacto"
                            value={userInputs.contact_number}
                            onChange={handleInputChange}
                            validation="phone"
                            horizontal={false}
                          />
                          <InputField 
                            title="Categoría:"
                            name="category"
                            placeholder="Categoría"
                            value={userInputs.category}
                            onChange={handleInputChange}
                            horizontal={false}
                            maxLength={50}
                          />
                          
                          <SelectSearch
                            title="Proveedor:"
                            name="supplierId"
                            value={selectedSupplier}
                            onChange={handleSupplierChange}
                            options={supplierOptions}
                            placeholder="Proveedor"
                            isDisabled={loadingSuppliers}
                            isLoading={loadingSuppliers}
                            horizontal={false}
                            required={true}
                          />
                          
                        </>
                      )}

                      {/* Campos para Comprador */}
                      {selectedRole === 3 && (
                        <>
                          <InputField 
                            title="Nombres y apellidos:"
                            name="name"
                            placeholder="Nombres y Apellidos"
                            value={userInputs.name}
                            onChange={handleInputChange}
                            validation="letters-only"
                            required={true}
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Correo de la empresa:"
                            name="email"
                            placeholder="Correo de la empresa"
                            value={userInputs.email}
                            onChange={handleInputChange}
                            type="email"
                            validation="email"
                            required={true}
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Número de contacto:"
                            name="contact_number"
                            placeholder="Número de contacto"
                            value={userInputs.contact_number}
                            onChange={handleInputChange}
                            validation="phone"
                            horizontal={false}
                          />
                          <InputField
                            title="Cargo:"
                            placeholder="Cargo"
                            name="charge"
                            value={userInputs.charge}
                            onChange={handleInputChange}
                            horizontal={false}
                            maxLength={50}
                          />
                          <SelectSearch
                            title="Grupo de compras:"
                            name="purchasingGroupId"
                            value={selectedBuyerGroups}
                            onChange={handleBuyerGroupsChange}
                            options={buyersGroupOptions}
                            placeholder="Grupo de compras"
                            isDisabled={loadingBuyersGroups}
                            isLoading={loadingBuyersGroups}
                            horizontal={false}
                          />

                          <SelectSearch
                            title="Subtipo de mantenimiento:"
                            name="subtypeIds"
                            value={selectedSubtypes}
                            onChange={handleSubtypesChange}
                            options={subtypes}
                            placeholder="Subtipo de mantenimiento"
                            isDisabled={loadingSubtypes}
                            isLoading={loadingSubtypes}
                            horizontal={false}
                            isMulti ={true}
                          />
                        </>
                      )}

                      {/* Campos para Invitado */}
                      {selectedRole === 4 && (
                        <>
                          <InputField 
                            title="Código:"
                            name="user_code"
                            placeholder="Código"
                            value={userInputs.user_code}
                            onChange={handleInputChange}
                            validation="numeric"
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Nombres y Apellidos:"
                            name="name"
                            placeholder="Nombres y Apellidos"
                            value={userInputs.name}
                            onChange={handleInputChange}
                            validation="letters-only"
                            horizontal={false}
                            required={true}
                            maxLength={50}
                          />
                          <InputField 
                            title="División de personal:"
                            name="personnel_division"
                            placeholder="División de personal"
                            value={userInputs.personnel_division}
                            onChange={handleInputChange}
                            validation="alphanumeric"
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Posición:"
                            name="position"
                            placeholder="Posición"
                            value={userInputs.position}
                            onChange={handleInputChange}
                            validation="numeric"
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Correo:"
                            name="email"
                            placeholder="Correo"
                            value={userInputs.email}
                            onChange={handleInputChange}
                            type="email"
                            validation="email"
                            horizontal={false}
                            required={true}
                            maxLength={50}
                          />
                          <InputField 
                            title="Gerencia jerarquica:"
                            name="hierarchichal_manage"
                            placeholder="Gerencia jerarquica"
                            value={userInputs.hierarchichal_manage}
                            onChange={handleInputChange}
                            validation="alphanumeric"
                            horizontal={false}
                            maxLength={50}
                          />
                          <InputField 
                            title="Área funcional:"
                            name="functional_area"
                            placeholder="Área funcional"
                            value={userInputs.functional_area}
                            onChange={handleInputChange}
                            validation="alphanumeric"
                            horizontal={false}
                            maxLength={50}
                          />
                        </>
                      )}
                    </div>
                </div>
                {selectedRole && (
                <div className="flex items-center justify-center pt-28">
                <div className="flex w-full md:w-[65%] gap-7 items-center justify-center">
                          <SaveButton 
                            onClick={handleSubmit} 
                            type="submit"
                            loading={isLoading}
                            disabled={isLoading}
                          />
                          <CancelButton onClick={handleCancel}/>
</div>
                </div>
                )}
            
        </div>
      </div>

      {/** administrador */}
      {selectedRole === 1 && (
        <UploadDocument 
        showModalUploadDocument={showModalUploadDocument}
        closeModal={closeModal}
        acceptFiles=".xlsx, .xls"
        fieldMapping={{
          name: "Nombre completo (*)",
          email: "Correo electrónico (*)",
          contact_number: "Número de contacto",
        }}
        onFileProcessed={handleExcelUploadAdmin}
      />
      )}
      {/**proveedor */}
      {selectedRole === 2 && (
        <UploadDocument 
        showModalUploadDocument={showModalUploadDocument}
        closeModal={closeModal}
        acceptFiles=".xlsx, .xls"
        fieldMapping={{
          name: "Nombre completo (*)",
          email: "Correo electrónico (*)",
          contact_number: "Número de contacto",
          charge: "Cargo",
          category: "Categoría",
          supplier: "Proveedor (*)"
        }}
        onFileProcessed={handleExcelUploadProvider}
      />
      )}

      {/**comprador*/}
      {selectedRole === 3 && (
        <UploadDocument 
        showModalUploadDocument={showModalUploadDocument}
        closeModal={closeModal}
        acceptFiles=".xlsx, .xls"
        fieldMapping={{
          name: "Nombre completo (*)",
          email: "Correo electrónico (*)",
          contact_number: "Número de contacto",
          charge: "Cargo",
          purchasingGroup: "Grupo de compras",
          subtipos: "Subtipos",
          roleName: "Rol"
        }}
        onFileProcessed={handleExcelUploadBuyer}
      />
      )}

      {/**invitado*/}
      {selectedRole === 4 && (
        <UploadDocument 
        showModalUploadDocument={showModalUploadDocument}
        closeModal={closeModal}
        acceptFiles=".xlsx, .xls"
        fieldMapping={{
          user_code: "Código (*)",
          name: "Nombre completo (*)",
          personnel_division: "División de personal",
          position: "Posición",
          email: "Correo electrónico (*)",
          hierarchichal_manage: "Gerencia jerárquica",
          functional_area: "Área funcional",
          roleName: "Rol"
        }}
        onFileProcessed={handleExcelUploadGuest}
      />
      )}

      <ModalAlertWarning 
        showModalAlertWarning={showModalAlertWarning}
        closeModal={closeModalWarning}
        error={errorMessage}
        accept={closeModalWarning}
      />

      <ModalSuccess 
        showModalSuccess={showModalSuccess}
        closeModalSuccess={closeModalSuccess}
        fill="green" 
        text={successMessage}
      />

      <ModalUserError 
        showModal={showModalUserError}
        errorMessage={errorMessage}
        excelData={errorExcelData}
        validationMessages={validationMessages}
        closeModal={() => {
          setShowModalUserError(false);
          setErrorExcelData(null);
          setErrorMessage('');
          setValidationMessages([]);
        }}
        title="Se encontraron errores"
      />


    </div>
  );
}